import {
  Alert,
  AlertDescription,
  AlertTitle,
  Box,
  Icon,
} from '@chakra-ui/react';
import { ContentContainer } from 'app/components/Core';
import { ContentContainerType } from 'types/enums';
import { ReactComponent as InfoSvg } from 'resources/images/info.svg';

export const QuotaExceededAlert = () => {
  return (
    <ContentContainer
      type={ContentContainerType.LIST}
      py={6}
      paddingBottom={0}
      flex="initial"
    >
      <Box>
        <Alert maxW="inherit" w="100%" bg="R.20">
          <Box mr="2">
            <Icon as={InfoSvg} color="M.70" />
          </Box>
          <Box>
            <AlertTitle mb={-2} color="white">
              Export Failed
            </AlertTitle>
            <AlertDescription color="M.70">
              SoundCloud Limit Exceeded
            </AlertDescription>
          </Box>
        </Alert>
      </Box>
    </ContentContainer>
  );
};
